export function VectorMarketplaceIcon({ height = 14 }: { height?: number }) {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="7" fill="#6A4EDE" />
      <path
        d="M3.79167 4.20011H5.68685L6.99047 7.37701H7.0562L8.35982 4.20011H10.255V9.80897H8.76515V6.56635H8.72133L7.47248 9.76515H6.57419L5.32534 6.54444H5.28152V9.80897H3.79167V4.20011Z"
        fill="white"
      />
    </svg>
  );
}
